export default function AboutUs() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety First',
      description: 'Your safety is our top priority. All our vessels are maintained to the highest standards and our crew is extensively trained in safety procedures.'
    },
    {
      icon: 'ri-star-line',
      title: 'Excellence',
      description: 'We strive for mastery in every detail, from yacht deliveries to competitive racing. We provide elite seamanship where precision meets the adventure.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Passion',
      description: 'Our love for sailing drives us to share this incredible sport with others and create a welcoming community of sailing enthusiasts.'
    },
    {
      icon: 'ri-earth-line',
      title: 'Sustainability',
      description: 'We are committed to protecting our oceans and marine environment through responsible sailing practices and education.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About Us
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover our story and commitment to providing exceptional sailing experiences
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative h-96 lg:h-full min-h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/aa24b33cc8fe53666876038a9f4ae426.jpeg"
              alt="Our Team"
              className="w-full h-full object-cover object-center"
            />
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Our Story
            </h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Founded in 2025 by Caner Akdolun, Sail Rebels began with a simple mission: to share our passion for sailing and make this incredible sport accessible to everyone. We are a collective of sailors, racers, and dreamers who share a deep respect for the sea and a commitment to genuine seamanship.For over 25 years, Caner has followed the winds across the USA, the Caribbean, Mexico, the Northern Mediterranean, and Atlantic France. His journey began as a kid, falling in love with the sea as an Optimist class racer, and evolved through years of team inshore and offshore racing. Taking the step into solo offshore racing on boats like the Mini 6.50 was a natural progression in a life dedicated to the water. Whether commanding a high-performance race boat or a cruising catamaran, the goal has always been the same: Adventure.Today, Caner and his hand-picked team of elite captains represent the pinnacle of maritime expertise. We strive to be the best in the industry—whether it is executing precise global yacht deliveries, leading racing crews, or providing professional charter skippering. We are dedicated to delivering the highest quality of service without ever losing our adventurous spirit or our profound respect for the elements.At Sail Rebels, we prioritize tailored experiences over mass-market solutions. Whether you are looking for high-quality cruising, chasing the adrenaline of racing, or an adventurous skipper looking to join our ranks, our doors are open to everyone who honors the ocean and respects the environment. We believe true sailing is about responsibility, continuous learning, and honoring the unique path of every sailor who joins our community.Join us, and feel the thrill of the adventure.
              </p>
              <p>
                Over the past 25 years, we've helped thousands of people discover the joy of sailing, from complete beginners taking their first steps on a boat to experienced sailors honing their racing skills. Our team of certified instructors brings decades of combined experience and a genuine love for teaching.
              </p>
              <p>
                Today, we offer comprehensive programs including recreational cruising, competitive racing, and professional training courses. Our fleet has expanded to include over 100 vessels, ranging from training dinghies to luxury cruising yachts, all maintained to the highest safety standards.
              </p>
              <p>
                We're proud to be part of a vibrant sailing community and remain committed to our founding principles: safety, excellence, and sharing the transformative experience of sailing with everyone who walks through our doors.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Our Values
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-slate-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
